/* import __COLOCATED_TEMPLATE__ from './page-click.hbs'; */
var _dec, _dec2, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
let PageClickComponent = (_dec = service('ember-multipass-logging'), _dec2 = service('ember-multipass-tracking'), (_class = class PageClickComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "logger", _descriptor, this);
    _initializerDefineProperty(this, "tracking", _descriptor2, this);
    _defineProperty(this, "initPageClick", el => {
      if (el.childElementCount !== 1) {
        throw new Error('Page click tracker only supports single child element');
      }
      el.children[0].addEventListener('click', this.click);
    });
    _defineProperty(this, "click", event => {
      try {
        const elementData = {
          elementIdentifier: this.args.trackId ?? event.target.id,
          elementText: this.args.trackText ?? event.target.textContent.trim().replace(/\s+/g, ' ').slice(0, 300),
          elementTitle: this.args.trackTitle ?? event.target.title,
          elementType: event.target.tagName.toLowerCase()
        };
        if (this.args.type === 'link') {
          this.tracking.trackLinkClick(elementData);
        } else if (this.args.type === 'button') {
          this.tracking.trackButtonClick(elementData);
        }
      } catch (e) {
        // tracking errors should not bubble and interfere w/ application flow
        this.logger.error(e);
      }
    });
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "logger", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "tracking", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));
export { PageClickComponent as default };